<section class="cmn-innerpage-wrapper">
  <div class="inner-content dashboard" *ngIf="!contentLoading">
    <div class="head">
      <h1>{{ badgeId ? "Edit Badge" : "Add New Badge" }}</h1>
    </div>
    <form id="translation" [formGroup]="mainForm" (submit)="createBadge()">
      <div class="challengeLangWrapper">
        <div class="challengeFormWrapper">
          <div class="days-words-wrapper">
            <label>
              <span>Badge Type</span>
              <mat-form-field appearance="fill">
                <mat-select placeholder="Badge Type" formControlName="badgeType">
                  <mat-option *ngFor="let option of badgeTypeOptions" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="mainForm.get('badgeType')?.hasError('required')">
                  Badge Type is required
                </mat-error>
              </mat-form-field>
            </label>
            <ng-container *ngIf="mainForm.get('badgeType')?.value === 'event'">
              <label>
                <span>From</span>
                <mat-form-field appearance="fill">
                  <input matInput [matDatepicker]="fromPicker" placeholder="Start Date" formControlName="from"
                    [matDatepickerFilter]="combinedFilterFrom" readonly />
                  <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
                  <mat-datepicker #fromPicker></mat-datepicker>
                  <mat-error *ngIf="mainForm.get('from')?.hasError('required')">
                    Start date is required
                  </mat-error>
                </mat-form-field>
              </label>
              <label>
                <span>To</span>
                <mat-form-field appearance="fill">
                  <input matInput [matDatepicker]="toPicker" placeholder="End Date" formControlName="to"
                    [matDatepickerFilter]="combinedFilterTo" readonly />
                  <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
                  <mat-datepicker #toPicker></mat-datepicker>
                  <mat-error *ngIf="mainForm.get('to')?.hasError('required')">
                    End date is required
                  </mat-error>
                </mat-form-field>
              </label>
            </ng-container>
            <label>
              <span>Type</span>
              <mat-form-field appearance="fill">
                <mat-select placeholder="Type" formControlName="type">
                  <mat-option *ngFor="let option of subTypes" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="mainForm.get('type')?.hasError('required')">
                  Type is required
                </mat-error>
              </mat-form-field>
            </label>
          </div>
          <label class="image-wrapper-label block-pointer">
            <span>Upload Image</span>
            <div class="borderedWrapper">
              <div class="fileSection">
                <label for="imageFile" class="unblock-pointer">
                  Choose A File
                  <input type="file" id="imageFile" #imagefileInput (change)="onImageUpload($event)"
                    accept=".jpeg, .jpg, .png, .webp" formControlName="imageURL" />
                </label>
                <div class="uploadedFiles" *ngIf="imageFileName">
                  <ul>
                    <li>
                      <h6 class="uploaded-file-name">{{ imageFileName }}</h6>
                      <img src="../../../assets/images/icons/icon-close.svg" alt="Remove" style="cursor: pointer"
                        class="unblock-pointer" (click)="clearImageUpload()" />
                    </li>
                  </ul>
                </div>
              </div>
              <h6>
                Image should be in JPG, JPEG or PNG format and not exceed 15MB
                in size.
              </h6>
            </div>
          </label>
        </div>
        <div class="type-conditions-wrapper">
          <label>
            <span>Points</span>
            <mat-form-field appearance="fill">
              <input matInput type="text" formControlName="point" placeholder="Points"
                (keydown.space)="$event.preventDefault()" (keydown)="blockNegativeNumbers($event)"
                (paste)="onPaste($event)" />
              <mat-error *ngIf="mainForm.get('point')?.hasError('required')">
                Points are required
              </mat-error>
              <mat-error *ngIf="mainForm.get('point')?.hasError('min')">
                Points must be between 1 and 5000
              </mat-error>
              <mat-error *ngIf="mainForm.get('point')?.hasError('max')">
                Points must be between 1 and 5000
              </mat-error>
              <mat-error *ngIf="mainForm.get('point')?.hasError('numbersOnly')">
                Points must be an integer value
              </mat-error>
            </mat-form-field>
          </label>
          <label *ngIf="showMinutes" class="block-pointer">
            <span>Minutes</span>
            <mat-form-field>
              <input type="text" matInput placeholder="Minutes" formControlName="minutes"
                (keydown)="blockNegativeNumbers($event)" (paste)="onPaste($event)" />
              <mat-error *ngIf="mainForm.get('minutes')?.hasError('required')">
                Minutes is required
              </mat-error>
              <mat-error *ngIf="mainForm.get('minutes')?.hasError('min')">
                Minutes must be at least 1 and less than 1,00,000
              </mat-error>
              <mat-error *ngIf="mainForm.get('minutes')?.hasError('max')">
                Minutes must be at least 1 and less than 1,00,000
              </mat-error>
              <mat-error *ngIf="mainForm.get('minutes')?.hasError('numbersOnly')">
                Minutes must be an integer value
              </mat-error>
            </mat-form-field>
          </label>
          <label *ngIf="showDays" class="block-pointer">
            <span>Days</span>
            <mat-form-field>
              <input type="text" matInput placeholder="Days" formControlName="inDays"
                (keydown)="blockNegativeNumbers($event)" (paste)="onPaste($event)" />
              <mat-error *ngIf="mainForm.get('inDays')?.hasError('required')">
                Days is required
              </mat-error>
              <mat-error *ngIf="mainForm.get('inDays')?.hasError('min')">
                Days must be at least 1 and less than 1000
              </mat-error>
              <mat-error *ngIf="mainForm.get('inDays')?.hasError('max')">
                Days must be at least 1 and less than 1000
              </mat-error>
              <mat-error *ngIf="mainForm.get('inDays')?.hasError('numbersOnly')">
                Days must be an integer value
              </mat-error>
            </mat-form-field>
          </label>
          <label *ngIf="showWords" class="block-pointer">
            <span>Word count</span>
            <mat-form-field>
              <input type="text" matInput placeholder="Word count" formControlName="words"
                (keydown)="blockNegativeNumbers($event)" (paste)="onPaste($event)" />
              <mat-error *ngIf="mainForm.get('words')?.hasError('required')">
                Word count is required
              </mat-error>
              <mat-error *ngIf="mainForm.get('words')?.hasError('min')">
                Word count must be at least 50 and less than 5,00,000
              </mat-error>
              <mat-error *ngIf="mainForm.get('words')?.hasError('max')">
                Word count must be at least 50 and less than 5,00,000
              </mat-error>
              <mat-error *ngIf="mainForm.get('words')?.hasError('numbersOnly')">
                Word count must be an integer value
              </mat-error>
            </mat-form-field>
          </label>
          <label *ngIf="showCount" class="block-pointer">
            <span style="text-transform: none">Book(s) read</span>
            <mat-form-field>
              <input type="text" matInput placeholder="Book count" formControlName="count"
                (keydown)="blockNegativeNumbers($event)" (paste)="onPaste($event)" />
              <mat-error *ngIf="mainForm.get('count')?.hasError('required')">
                Book count is required
              </mat-error>
              <mat-error *ngIf="mainForm.get('count')?.hasError('min')">
                Book count must be at least 1 and less than 1000
              </mat-error>
              <mat-error *ngIf="mainForm.get('count')?.hasError('max')">
                Book count must be at least 1 and less than 1000
              </mat-error>
              <mat-error *ngIf="mainForm.get('count')?.hasError('numbersOnly')">
                Book count must be an integer value
              </mat-error>
            </mat-form-field>
          </label>
        </div>
        <div class="challengeFormWrapper">
          <label class="width-Wrapper">
            <span>Choose language</span>
            <mat-form-field appearance="fill">
              <mat-select formControlName="langId" placeholder="Language">
                <mat-option *ngFor="let lang of languages" [value]="lang.id" [disabled]="isLangUsed(lang.id)">
                  {{ lang.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="mainForm.get('langId')?.hasError('required')">Language is required</mat-error>
            </mat-form-field>
          </label>
          <label class="full-width-wrapper block-pointer">
            <span>Badge Name</span>
            <mat-form-field>
              <input type="text" matInput placeholder="Badge Name" formControlName="title" />
              <mat-error *ngIf="mainForm.get('title')?.hasError('required')">Badge Name is required</mat-error>
              <mat-error *ngIf="mainForm.get('title')?.hasError('maxlength')">Badge Name cannot exceed 150
                characters</mat-error>
              <mat-error *ngIf="mainForm.get('title')?.hasError('onlySpecialAlphaChars')">Badge Name cannot contain only
                special characters and
                numbers</mat-error>
              <mat-error *ngIf="mainForm.get('title')?.hasError('onlySpaces')">Badge Name cannot be empty</mat-error>
            </mat-form-field>
          </label>
        </div>
        <div class="add-btn-div">
          <p [style.visibility]="
              badgeTranslations.length === 0 ? 'visible' : 'hidden'
            ">
            Add at least one translation to save
          </p>
          <button (click)="addBadgeTable()" type="button" class="add-button unblock-pointer"
            *ngIf="badgeTranslations.length !== languages.length">
            <span>Add</span>
          </button>
        </div>
      </div>
      <div *ngIf="badgeTranslations?.length" class="tableWrapper">
        <table>
          <thead>
            <tr>
              <th>No</th>
              <th>Language</th>
              <th>Badge name</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let badge of badgeTranslations; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ getLanguageName(badge.langId) }}</td>
              <td class="content-row">{{ badge.title }}</td>
              <td>
                <div class="actionWrapper">
                  <div *ngIf="badge.langId !== 1" class="actionItem"
                    (click)="onDeleteBadgeTranslation(badge.langId, i)">
                    <img src="../../../assets/images/icons/icon-delete.svg" alt="" />
                  </div>
                  <div class="actionItem" (click)="editBadgeTranslation(i)">
                    <img src="../../../assets/images/icons/icon-edit.svg" alt="" />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="btnWrapper">
        <button class="cmn-cancel-btn" (click)="onCancel()">Cancel</button>
        <button [disabled]="!badgeTranslations.length || isSubmitting" class="cmn-next-btn" type="submit">
          {{ badgeId ? "Update" : "Save" }}
        </button>
      </div>
    </form>
  </div>
  <app-content-loader [visible]="contentLoading"></app-content-loader>
</section>

<app-fullscreen-loader [visible]="imageUploading || loading" [message]="
    imageUploading ? 'Uploading file, please wait...' : 'Saving, Please wait'
  ">
</app-fullscreen-loader>
